<!-- If not logged in, then show pre-seen screen -->
<div *ngIf="!isLoggedIn">
    <navbar-cmp></navbar-cmp>
    <div class="guest-image-container">
        <img class="guest-background-img" src="assets/img/api-explorer-pre-signup-background.png" alt="" />
        <div class="guest-background-overlay"></div>
    </div>
    <div class="guest-content">
        <h1 class="guest-title">Start building <span>with Pay10</span></h1>
        <p class="guest-description">
            Get API keys, test in sandbox, and start processing payments in minutes.
        </p>
        <button class="btn-get-started-guest" (click)="navigateToSignup()">
            Get Started
        </button>
    </div>
</div>

<!-- If logged in, then show the integration guide -->
<div *ngIf="isLoggedIn" class="main-container">
    <div class="integration-hero" *ngIf="!selectedApi">
        <div class="hero-content">
            <h1 class="hero-title">
                <span class="title-pay10">Pay10</span>
                <span class="title-integration">API Explorer</span>
            </h1>
            <p class="hero-subtitle">
                Test and explore Pay10 APIs in real time.
            </p>
            <p class="hero-description">
                Send requests, view instant responses, and understand API behavior with interactive examples designed to speed up your integration.
            </p>
            <button class="btn-get-started" (click)="navigateToFirstMenuItem()">
                Get Started
            </button>
        </div>
        <div class="hero-illustration">
            <img src="assets/img/api-explorer-illustration.png" alt="API Explorer illustration"
                class="illustration-img" />
        </div>
    </div>

    <!-- If logged in and selected an API, then show the API details -->
    <div class="api-doc-page" *ngIf="selectedApi">
        <div class="api-state-card" *ngIf="isLoadingApiDetails">
            Loading API details...
        </div>

        <div class="api-state-card api-error-card" *ngIf="apiDetailsError && !isLoadingApiDetails">
            {{ apiDetailsError }}
        </div>

        <div class="api-doc-layout" *ngIf="apiDetails && !isLoadingApiDetails && !apiDetailsError">
            <main class="api-doc-main">
                <div class="api-content-card">

                    <div class="api-doc-intro">
                        <h1>{{ apiDetails.title }}</h1>
                        <!-- <p *ngIf="apiDetails.version">Version {{ apiDetails.version }}</p> -->
                        <p *ngIf="apiDetails.endpoints?.[0]?.description" class="api-description">
                            {{ apiDetails.endpoints[0].description }}
                        </p>
                    </div>

                    <!-- Note banner for docs that carry one but still want the environment card
                         (payout entries use this to explain the encrypted envelope). -->
                    <div class="api-explorer-note"
                         *ngIf="apiDetails.note?.content && selectedApi !== 'webhook'">
                        <span class="api-explorer-note-text">{{ apiDetails.note.content }}</span>
                    </div>

                    <ng-container *ngIf="selectedApi === 'webhook'; else envCard">
                        <div class="api-explorer-note">
                            <span class="api-explorer-note-text">{{ apiDetails.note?.content }}</span>
                        </div>
                    </ng-container>
                    <ng-template #envCard>
                        <div class="environment-card">
                            <div class="environment-row">
                                <strong>Sandbox Environment</strong>
                                <code>{{ sandboxUrl }}</code>
                            </div>
                            <div class="environment-row">
                                <strong>Production Environment</strong>
                                <code>{{ productionUrl }}</code>
                            </div>
                        </div>
                    </ng-template>

                    <ng-container *ngFor="let endpoint of apiDetails.endpoints">
                        <!-- sample request -->
                        <div class="inner-section code-card" [class.collapsed]="!isSampleRequestOpen"
                            *ngIf="selectedApi !== 'webhook'">
                            <div class="section-heading" (click)="toggleSampleRequest()">
                                <span>
                                    Sample Request
                                    <img class="code-tag" src="assets/icons/sample-request.svg" alt="Sample Request">
                                </span>
                                <span class="chevron-mid" [class.open]="isSampleRequestOpen"></span>
                            </div>
                            <div class="code-block-wrap" *ngIf="isSampleRequestOpen">
                                <div class="code-block-label">cURL</div>
                                <div class="code-block-body">
                                    <pre>{{ buildStaticCurlCommand(endpoint) }}</pre>
                                    <button class="copy-btn" (click)="copyStaticCurl(buildStaticCurlCommand(endpoint))"
                                        [class.copied]="copiedStaticCurl" title="Copy to clipboard">
                                        <img *ngIf="!copiedStaticCurl" src="assets/icons/copy.svg" alt="copy_curl">
                                        <img *ngIf="copiedStaticCurl" src="assets/icons/tick.svg" alt="tick_curl">
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- sample response -->
                        <div class="inner-section code-card"
                            *ngIf="endpoint.successResponse || endpoint.failureResponse"
                            [class.collapsed]="!isSampleResponseOpen">
                            <div class="section-heading" (click)="toggleSampleResponse()">
                                <span>
                                    Sample Response
                                    <img class="code-tag" src="assets/icons/sample-request.svg" alt="Sample Response">
                                </span>
                                <span class="chevron-mid" [class.open]="isSampleResponseOpen"></span>
                            </div>
                            <div *ngIf="isSampleResponseOpen" class="scenario-block">
                                <div *ngIf="endpoint.successResponse">
                                    <div class="scenario-heading">Success Scenario</div>
                                    <div class="code-block-wrap" *ngIf="endpoint.successResponse.content">
                                        <div class="code-block-label">{{ endpoint.successResponse.contentType }}</div>
                                        <div class="code-block-body">
                                            <pre>{{ endpoint.successResponse.content | json }}</pre>
                                            <button class="copy-btn"
                                                (click)="copySampleSuccess(endpoint.successResponse.content)"
                                                [class.copied]="copiedSampleSuccess" title="Copy">
                                                <img *ngIf="!copiedSampleSuccess" src="assets/icons/copy.svg"
                                                    alt="copy">
                                                <img *ngIf="copiedSampleSuccess" src="assets/icons/tick.svg"
                                                    alt="copied">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="endpoint.failureResponse">
                                    <div class="scenario-heading">Failure Scenario</div>
                                    <!-- <ul class="scenario-desc-list" *ngIf="endpoint.failureResponse.description">
                                        <li>{{ endpoint.failureResponse.description }}</li>
                                    </ul> -->
                                    <div class="code-block-wrap" *ngIf="endpoint.failureResponse.content">
                                        <div class="code-block-label">{{ endpoint.failureResponse.contentType }}</div>
                                        <div class="code-block-body">
                                            <pre>{{ endpoint.failureResponse.content | json }}</pre>
                                            <button class="copy-btn"
                                                (click)="copySampleFailure(endpoint.failureResponse.content)"
                                                [class.copied]="copiedSampleFailure" title="Copy">
                                                <img *ngIf="!copiedSampleFailure" src="assets/icons/copy.svg"
                                                    alt="copy">
                                                <img *ngIf="copiedSampleFailure" src="assets/icons/tick.svg"
                                                    alt="copied">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- path parameters -->
                        <ng-container *ngIf="filterParams(endpoint.parameters, 'path') as pathParams">
                            <div class="path-section" *ngIf="pathParams.length">
                                <div class="path-section-heading">Path Parameters</div>
                                <div class="params-list">
                                    <div class="params-table-header-path-param">
                                        <div class="params-th">Parameter</div>
                                        <div class="params-th">Reference</div>
                                    </div>
                                    <div class="param-row-path-param" *ngFor="let p of pathParams">
                                        <div class="param-left-path-param">
                                            <span class="param-name">{{ p.name }}</span>
                                        </div>
                                        <div class="param-right-path-param">
                                            <div>
                                                <div class="param-ref-row">
                                                    <span class="param-ref-name">{{ p.name }}</span>
                                                    <span class="param-type">
                                                        {{ p.schema?.type || '-' }}
                                                        <ng-container *ngIf="p.schema?.format"> ({{ p.schema.format}}) </ng-container>
                                                    </span>
                                                    <span class="required-text" *ngIf="p.required">required</span>
                                                </div>
                                                <span class="param-desc" *ngIf="p.description">{{ p.description }}</span>
                                            </div>
                                            <div>
                                                <input class="param-input-path-param" type="text"
                                                    [(ngModel)]="paramValues[p.name]"
                                                    [placeholder]="p.schema?.example || p.name">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>


                        <!-- headers -->
                        <ng-container *ngIf="filterParams(endpoint.parameters, 'header') as headerParams">
                            <div class="header-section"
                                *ngIf="headerParams.length > 0 && !(headerParams.length === 1 && headerParams[0].name.toLowerCase() === 'authorization')">
                                <div class="header-section-heading">Headers</div>
                                <div class="params-list">
                                    <!-- <div class="params-table-header">
                                        <div class="params-th">Parameter</div>
                                        <div class="params-th">Reference</div>
                                        <div class="params-th"></div>
                                    </div> -->
                                    <ng-container *ngFor="let p of headerParams">
                                        <div class="param-row-headers" *ngIf="p.name.toLowerCase() !== 'authorization'">
                                            <div class="param-content-headers">
                                                <div class="param-ref-row">
                                                    <span class="param-ref-name">{{ p.name }}</span>
                                                    <span class="param-type">{{ p.schema?.type || '-' }}</span>
                                                    <span class="required-text" *ngIf="p.required">required</span>
                                                </div>
                                                <span class="param-desc" *ngIf="p.description">{{ p.description }} </span>
                                            </div>
                                            <div class="param-input-col-headers">
                                                <input class="param-input"
                                                    [type]="(p.schema?.type === 'integer' || p.schema?.type === 'number') ? 'number' : 'text'"
                                                    [(ngModel)]="paramValues[p.name]"
                                                    [placeholder]="p.schema?.example || p.name">
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>

                        <!-- query params -->
                        <ng-container *ngIf="filterParams(endpoint.parameters, 'query') as queryParams">
                            <div class="params-section" *ngIf="queryParams.length">
                                <div class="params-section-heading">Query Parameters</div>
                                <div class="params-list">
                                    <!-- <div class="params-table-header">
                                        <div class="params-th">Parameter</div>
                                        <div class="params-th">Reference</div>
                                        <div class="params-th"></div>
                                    </div> -->
                                    <div class="param-row-query" *ngFor="let p of queryParams">
                                        <div class="param-content-query">
                                            <div class="param-ref-row">
                                                <span class="param-ref-name">{{ p.name }}</span>
                                                <span class="param-type">{{ p.schema?.type || '-' }}<ng-container
                                                        *ngIf="p.schema?.format"> ({{ p.schema.format
                                                        }})</ng-container></span>
                                                <span class="required-text" *ngIf="p.required">required</span>
                                            </div>
                                            <span class="param-desc" *ngIf="p.description">{{ p.description }}</span>
                                        </div>
                                        <div class="param-input-col-query">
                                            <select *ngIf="p.schema?.enum?.length; else queryTextInput"
                                                class="param-input param-select" [(ngModel)]="paramValues[p.name]">
                                                <option value="" disabled selected>{{ p.schema?.example || p.name }}
                                                </option>
                                                <option *ngFor="let opt of p.schema.enum" [value]="opt">{{ opt }}
                                                </option>
                                            </select>
                                            <ng-template #queryTextInput>
                                                <input class="param-input"
                                                    [type]="(p.schema?.type === 'integer' || p.schema?.type === 'number') ? 'number' : 'text'"
                                                    [(ngModel)]="paramValues[p.name]"
                                                    [placeholder]="p.schema?.example || p.name">
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <!-- request body -->
                        <div class="body-section" *ngIf="endpoint.requestBodyFields?.length">
                            <div class="body-section-heading">Request Body</div>
                            <div class="params-list">
                                <div class="params-table-header-body">
                                    <span class="params-th">Parameter</span>
                                </div>
                                <ng-container
                                    *ngTemplateOutlet="bodyFieldRows; context: { $implicit: endpoint.requestBodyFields, prefix: '', depth: 0 }"></ng-container>

                                <!--
                                    Request-body rows, rendered recursively so that nested object and
                                    array fields (batch payout transfers, scheduled payout items) appear
                                    as indented rows in the same table as flat fields.
                                -->
                                <ng-template #bodyFieldRows let-fields let-prefix="prefix" let-depth="depth">
                                    <ng-container *ngFor="let f of fields">
                                        <div class="param-row-body" [class.param-row-nested]="depth > 0"
                                            [style.paddingLeft.px]="depth * 16">
                                            <div class="param-content-body">
                                                <div class="param-ref-row">
                                                    <span class="param-ref-name">{{ f.name }}</span>
                                                    <span class="param-type">{{ bodyFieldType(f) }}</span>
                                                    <span class="required-text" *ngIf="f.required">required</span>
                                                </div>
                                                <span class="param-desc" *ngIf="f.description">{{ f.description }}</span>
                                                <div class="params-list" *ngIf="f.schema?.type.startsWith('array') && f.schema?.fields?.length > 0" >
                                                    <div class="param-row-body" *ngFor="let nestF of visibleNestBodyFields(f)">
                                                        <div class="param-content-body">
                                                            <div class="param-ref-row">
                                                                <span class="param-ref-name">{{ nestF.name }}</span>
                                                                <span class="param-type">{{ nestF.schema?.type || '-' }}</span>
                                                                <span class="required-text" *ngIf="nestF.required">required</span>
                                                            </div>
                                                            <span class="param-desc" *ngIf="nestF.description">{{ nestF.description }}</span>
                                                        </div>
                                                    </div>
                                                </div>        
                                            </div>
                                            <div class="param-input-col-body">
                                                <ng-container *ngIf="f.schema?.type === 'file' || f.schema?.format === 'binary'; else nonFileBody">
                                                    <input class="param-input" type="file"
                                                        accept=".csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                                                        (change)="onFileSelected(f.name, $event)">
                                                    <span class="param-desc" *ngIf="fileValues[f.name]">{{ fileValues[f.name]?.name }}</span>
                                                </ng-container>
                                                <ng-template #nonFileBody>
                                                <ng-container *ngIf="f.schema?.type?.startsWith('array') && f.schema?.fields?.length > 0; else normalBodyField">
                                                    <textarea id="body-array-textarea" class="param-input textarea-input" #autoTextarea [disabled]="isFieldFixed(f)"
                                                        [value]="formatJson(bodyValues[f.name])"
                                                        (input)="onJsonInput(f.name, $any($event.target).value); resizeTextarea($any($event.target))"></textarea>
                                                </ng-container>
                                                <ng-template #normalBodyField>
                                                    <ng-container *ngIf="!f.schema?.fields?.length">
                                                        <select *ngIf="f.schema?.enum?.length; else bodyTextInput" class="param-input param-select"
                                                            [(ngModel)]="bodyValues[bodyKey(prefix, f)]" [ngModelOptions]="{ standalone: true }">
                                                            <option value="" disabled selected>{{ f.schema?.example || f.name }}
                                                            </option>
                                                            <option *ngFor="let opt of f.schema.enum" [value]="opt">{{ opt }}</option>
                                                        </select>
                                                        <ng-template #bodyTextInput>
                                                            <input class="param-input"
                                                                [type]="(f.schema?.type === 'integer' || f.schema?.type === 'number') ? 'number' : 'text'"
                                                                [(ngModel)]="bodyValues[bodyKey(prefix, f)]" [ngModelOptions]="{ standalone: true }"
                                                                [placeholder]="f.schema?.example || f.name">
                                                        </ng-template>
                                                    </ng-container>
                                                </ng-template>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-template>
                            </div>
                        </div>

                        <!-- response -->
                        <div class="response-section" *ngIf="endpoint.responses?.length">
                            <div class="response-section-heading">
                                Response
                            </div>
                            <div class="response-list">
                                <div class="response-item" *ngFor="let response of endpoint.responses">
                                    <div class="response-title-row" (click)="toggleResponseItem(response.status)">
                                        <div class="response-title-left">
                                            <div class="response-status-line">
                                                <img *ngIf="response.status.startsWith('2')"
                                                    src="assets/icons/success.svg" class="response-status-icon"
                                                    alt="success">
                                                <img *ngIf="!response.status.startsWith('2')"
                                                    src="assets/icons/Failed.svg" class="response-status-icon"
                                                    alt="failed">
                                                <strong>{{ response.status }}</strong>
                                            </div>
                                            <p class="response-desc">{{ response.description || 'No description
                                                available' }}</p>
                                        </div>
                                        <span class="chevron-mid" [class.open]="isResponseItemOpen(response.status)"></span>
                                    </div>
                                    <div *ngIf="isResponseItemOpen(response.status)">
                                        <div class="response-body-table" *ngIf="response.responseFields?.length">
                                            <div class="response-body-label">Response Body</div>
                                            <div class="response-field-row" *ngFor="let f of response.responseFields">
                                                <span class="response-field-name">{{ f.name?.trim() }} </span>
                                                <span class="response-field-type">{{ f.type }}</span>
                                                <span class="refund-badge" *ngIf="f.name?.trim() === 'REFUND_ORDER_ID'">Only for refunds</span>
                                                <span class="response-field-desc" *ngIf="f.description">{{ f.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </ng-container>

                    <div class="inner-section" *ngIf="!apiDetails.endpoints?.length">
                        <p style="padding:20px">No endpoints found in this OpenAPI response.</p>
                    </div>

                </div>

            </main>

            <!-- right side credential section  -->
            <aside class="api-console-panel">

                <ng-container *ngIf="isWebhookDoc; else curlPanel">
                    <div class="webhook-aside-img-wrap">
                        <img src="assets/img/webhook-aside.png" alt="Webhook" class="webhook-aside-img">
                    </div>
                </ng-container>
                <ng-template #curlPanel>
                    <section class="api-doc-card credentials-card"
                        *ngIf="selectedApi !== 'token' && selectedApi !== 'refresh' && apiDetails.endpoints?.[0]?.isFromPG === false">
                        <h3>Credentials</h3>
                        <div class="credential-input">
                            <span>Access Token</span>
                            <input type="text" placeholder="Paste Access Token from /Token" [(ngModel)]="accessToken" />
                            <img src="assets/icons/lock.svg" alt="lock" class="credential-lock-icon">
                        </div>
                    </section>
                    <section class="curl-doc-card " *ngIf="apiDetails.endpoints?.length && hasCallableEndpoint">
                        <div class="curl-card-header">
                            <div class="curl-format-trigger" (click)="toggleFormatDropdown()">
                                <h3>{{ curlFormat === 'curl' ? 'cURL' : 'HTTPie' }} Request</h3>
                                <span class="chevron" [class.open]="isCurlFormatDropdownOpen"></span>
                            </div>
                            <div class="curl-format-dropdown" *ngIf="isCurlFormatDropdownOpen">
                                <div class="curl-format-dropdown-label">Library</div>
                                <div class="curl-format-option" (click)="setCurlFormat('curl')">
                                    <span>cURL</span>
                                    <svg *ngIf="curlFormat === 'curl'" class="curl-format-check" viewBox="0 0 16 16"
                                        fill="none" stroke="currentColor" stroke-width="2.5">
                                        <polyline points="3 8 6.5 11.5 13 5"></polyline>
                                    </svg>
                                </div>
                                <div class="curl-format-option" (click)="setCurlFormat('httpie')">
                                    <span>HTTPie</span>
                                    <svg *ngIf="curlFormat === 'httpie'" class="curl-format-check" viewBox="0 0 16 16"
                                        fill="none" stroke="currentColor" stroke-width="2.5">
                                        <polyline points="3 8 6.5 11.5 13 5"></polyline>
                                    </svg>
                                </div>
                            </div>
                            <button class="header-copy-btn"
                                (click)="copyToClipboard(curlFormat === 'curl' ? buildCurlCommand(apiDetails.endpoints[0]) : buildHttpieCommand(apiDetails.endpoints[0]))"
                                [class.copied]="copiedCurl" title="Copy to clipboard">
                                <img *ngIf="!copiedCurl" src="assets/icons/copy-curl.svg" alt="copy">
                                <img *ngIf="copiedCurl" src="assets/icons/tick.svg" alt="copied">
                            </button>
                        </div>
                        <div class="curl-body">
                            <div class="curl-code-block-body">
                                <div *ngIf="curlFormat === 'curl'" class="curl-code-content"
                                    [innerHTML]="highlightCode(buildCurlCommand(apiDetails.endpoints[0]), 'curl')"></div>
                                <div *ngIf="curlFormat === 'httpie'" class="curl-code-content"
                                    [innerHTML]="highlightCode(buildHttpieCommand(apiDetails.endpoints[0]), 'httpie')"></div>
                                <div class="console-footer">
                                    <button class="btn-run" (click)="runApi()" [disabled]="isRunning">
                                        {{ isRunning ? 'Running...' : 'Run' }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="response-doc-card run-result-card" *ngIf="runResult">
                        <div class="run-result-status">
                            <span class="run-status-badge"
                                [class.success]="runResult.status >= 200 && runResult.status < 300"
                                [class.error]="runResult.status >= 400">
                                <img *ngIf="runResult.status >= 200 && runResult.status < 300"
                                    src="assets/icons/success.svg" alt="success">
                                <img *ngIf="runResult.status >= 400" src="assets/icons/Failed.svg" alt="failed">
                                {{ runResult.status }}
                            </span>
                            <button class="header-copy-btn" (click)="copyRunResult()" [class.copied]="copiedRunResult"
                                title="Copy">
                                <img *ngIf="!copiedRunResult" src="assets/icons/copy-curl.svg" alt="copy">
                                <img *ngIf="copiedRunResult" src="assets/icons/tick.svg" alt="copied">
                            </button>
                        </div>
                        <div class="run-result-body">
                            <pre [innerHTML]="highlightResponseJson(runResult.body)"></pre>
                        </div>
                    </section>
                </ng-template>
            </aside>

            <!-- Prev / Next page navigation — always last -->
            <div class="doc-nav-footer" *ngIf="prevMenuItem || nextMenuItem">
                <button *ngIf="prevMenuItem" class="doc-nav-btn" (click)="navigateToPrev()">
                    <div class="doc-nav-prev">
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="10 4 6 8 10 12"></polyline>
                        </svg>
                        <span>{{ prevMenuItem.nodeName }}</span>
                    </div>
                </button>
                <button *ngIf="nextMenuItem" class="doc-nav-btn doc-nav-next" (click)="navigateToNext()">
                    <div class="doc-nav-next">
                        <span>{{ nextMenuItem.nodeName }}</span>
                        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="6 4 10 8 6 12"></polyline>
                        </svg>
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>